import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const SurgardIntegrationFormSchema = zod
  .object({
    keepAliveInterval: zod.number(),
    type: zod.enum(['SERVER', 'CLIENT']),
    waitAck: zod.boolean(),
    serverIp: zod.string().optional(),
    serverPort: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
  })
  .merge(IntegrationFormSchema)
  .superRefine((arg, ctx) => {
    if (arg.type === 'CLIENT' && !arg.serverIp) {
      ctx.addIssue({
        code: 'custom',
        message: 'IP obrigatório',
        path: ['password'],
      });
    }
  });
